export default ({ COLORS }) => ({
  hint: {
    color: COLORS.TEXT.LIGHT_GREY.NORMAL,
    marginTop: '20px !important'
  },
  reSentMessage: {
    padding: '10px 0',
    margin: '0 !important',
    fontSize: '14px',
    color: COLORS.GREEN.NORMAL,
    fontWeight: 'bold'
  }
})
